import {
  Modal,
  ModalFooter,
  RadioGroup,
  RadioItem,
} from '@/src/components/Antd';
import React from 'react';
//import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import { getProducts, productsInit } from '@/src/request/product/product';
import css from './css.less';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import { SizeFittingTable } from 'src/components/Antd';

//import Pagination from 'src/components/StyledPagination/GlobalPagination';
import _ from 'lodash';
import { randomNumber } from 'src/tools/helper';
import { ProductSelectItem } from './types';

import _Query from 'src/constrains/Query1';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { useI18n } from 'src/hooks/useRouterChange';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { i18nGet } from 'src/tools/tools';
import {
  EnumProductProperty,
  EnumProductType,
  EnumStatus,
} from 'src/types/common/product';
import NoProduct from './NoProduct';
import { columns as _columns } from './TableCommon';
import {
  // updateMappedSelectedKeys as _updateMappedSelectedKeys,
  //onSelectChange as _onSelectChange,
  // generateMappedSelectedKeys,
  generateScrollProps,
  // onOkClick,
  onItemsChange,
} from './tools';

export enum SelectionType {
  Typed = 'Typed',
  General = 'General',
}
interface IProps {
  visible: boolean;
  selectedItems: any[];
  onCancel: () => void;
  onOk: (item) => void;
}
const convertQuery = (filter, customFilterTransfer) => {
  const re: any = {};
  if (filter.tags) {
    if (filter.tags.length > 0) {
      re.tags = filter.tags.map((i) => {
        const { value } = i;
        return { uuid: value };
      });
    }
  }
  if (filter.productTypes) {
    if (filter.productTypes.length > 0) {
      re.productTypes = filter.productTypes.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }
  if (customFilterTransfer) customFilterTransfer(filter, re);

  return re;
};

const queryConvert = (q, customFilterTransfer) => {
  const { search, filter, sort = {}, tableSettings = '' } = q || {};

  let _searchText = {};
  if (search && search.length > 0)
    _searchText = { searchText: (search || []).map((i) => i.value) };

  const filterData = convertQuery(filter, customFilterTransfer);

  let _sortBy = {};
  if (sort.data) {
    _sortBy = { sortBy: sort.data };
  }
  const res = {
    ..._searchText,
    ...filterData,
    ..._sortBy,
    ...{ tableSettings: tableSettings },
  };

  return res;
};

interface IProps {
  visible: boolean;
  selectedItems: any[];
  onCancel: () => void;
  onOk: (item) => void;
  salesChannelUuid?: string;
  columns?;
  customFilterTransfer?;
  extraFilters?;
  selectType?: SelectionType;
  fixedSearchConditions?: any;
  selectedProductsProperty?: any;
  hideDefaultTypeFilter?: boolean;
  hideAllDefaultTypeFilters?: boolean;
  extraProps?: any;
}
const ProductSelection = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    visible,
    onCancel,
    onOk,
    selectedItems = [],
    columns,
    customFilterTransfer,
    extraFilters = [],
    selectType = SelectionType.General,
    fixedSearchConditions: _fixedSearchConditions = {},
    selectedProductsProperty,
    hideDefaultTypeFilter,
    hideAllDefaultTypeFilters,
    extraProps,
  } = props;

  //console.log('props', props);
  //console.log('_fixedSearchConditions', _fixedSearchConditions);
  // const [loading, setLoading] = React.useState(false);
  const [hasInit, setHasInit] = React.useState(false);
  const [taggedList, setTaggedList] = React.useState([]);
  const [searchConditions, setSearchConditions] = React.useState({
    search: [],
    filter: {},
  });
  //console.log('searchConditions', searchConditions);

  const [current, setCurrent] = React.useState(0);
  const [, setTotal] = React.useState(0);
  const [pageSize] = React.useState(9999);
  //const [filter, setFilter] = React.useState<any>({});
  const [products, setProducts] = React.useState<any[]>([]);
  //console.log('products', products);
  const [currentProductsProperty, setCurrentProductsProperty] = React.useState(
    selectedProductsProperty || EnumProductProperty.Physical,
  );
  const isTyped = selectType === SelectionType.Typed;

  //const isGeneral = selectType === SelectionType.General;
  const fixedSearchConditions = {
    productStatuses: [EnumStatus.Active],
    ...(isTyped ? { category: currentProductsProperty } : {}),
    ..._fixedSearchConditions,
    // productTypes: [EnumProductType.Simple],
  };

  const search = React.useMemo(() => {
    return queryConvert(searchConditions, customFilterTransfer);
  }, [searchConditions]);

  const defaultFilter = () => {
    if (isTyped) {
      return {
        type: EnumFilterType.MultipleSelection,
        dropdownProps: { name: getI18n('general.type') },
        keyWord: 'productTypes',
        options:
          currentProductsProperty !== EnumProductProperty.Virtual
            ? [
                //定义排序所需的数据
                {
                  label: getI18n('general.simple'),
                  value: EnumProductType.Simple,
                },
                { label: getI18n('general.set'), value: EnumProductType.Set },
              ]
            : [
                //定义排序所需的数据
                {
                  label: getI18n('general.service'),
                  value: EnumProductType.Service,
                },
                {
                  label: getI18n('general.giftCard'),
                  value: EnumProductType.GiftCard,
                },
              ],
      };
    }

    return {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.type') },
      keyWord: 'productTypes',
      options: [
        //定义排序所需的数据
        { label: getI18n('general.simple'), value: EnumProductType.Simple },
        { label: getI18n('general.set'), value: EnumProductType.Set },
        { label: getI18n('general.service'), value: EnumProductType.Service },
        { label: getI18n('general.giftCard'), value: EnumProductType.GiftCard },
      ],
    };
  };

  const filters = () => {
    const basic: any = [
      {
        type: EnumFilterType.MultipleSelection,
        searchable: true,
        options: taggedList.map((i) => {
          const { name, uuid } = i;
          return { label: name, value: uuid };
        }),
        keyWord: 'tags',
        dropdownProps: { name: getI18n('general.tags') },
      },
    ];
    if (!hideDefaultTypeFilter) {
      const _f = defaultFilter();
      basic.push(_f);
    }
    //console.log('basic', basic);
    return [
      ...(hideAllDefaultTypeFilters ? [] : basic),
      ...(extraFilters || []),
    ];
  };

  // if (!hideDefaultTypeFilter) {
  //   _filters.push(defaultFilter());
  // }
  React.useEffect(() => {
    // getProduct(() => {});
    productsInit(current * pageSize, pageSize, fixedSearchConditions).then(
      (res) => {
        const { tags = [], products: { totalCount = 0, results = [] } = {} } =
          res;
        setTaggedList(tags);

        setTotal(totalCount);
        setProducts(results);
        setHasInit(true);
      },
    );
  }, []);

  const {
    onOk: onOkPress,
    onSelectChange,
    selectedRowKeys,
    //clearMapKeys,
  } = onItemsChange(selectedItems, products, onOk, onCancel, {
    noPagination: true,
    ...(extraProps || {}),
  });

  const rowSelectionType = React.useMemo(() => {
    // if (isTyped) {
    //   if (currentProductsProperty === EnumProductProperty.Virtual) {
    //     return { type: 'radio' };
    //   }
    // }
    return { type: 'checkbox' };
  }, [selectType, currentProductsProperty]);

  const rowSelection = {
    selectedRowKeys: selectedRowKeys.map((i) => i.uuid),
    onChange: onSelectChange,
    ...rowSelectionType,
    //type: 'radio',
  };
  // console.log('selectedRowKeys', selectedRowKeys);

  const getProduct = (cb) => {
    getProducts(current * pageSize, pageSize, {
      ...fixedSearchConditions,
      ...search,
    })
      .then((res) => {
        const { results, totalCount } = res;

        setTotal(totalCount);
        const products: ProductSelectItem[] = results.map((i) => {
          return {
            ...i,
            key: randomNumber(),
          };
        });

        setProducts(products);

        //setLoading(false);
      })
      .then(() => {
        if (cb) cb();
      });

    // console.log(product);
  };

  useAfterDidMountEffect(() => {
    getProduct(() => {
      console.log('getProduct1');
    });
  }, [current, search, currentProductsProperty]);
  //search;

  useAfterDidMountEffect(() => {
    if (!current) {
      getProduct(() => {
        console.log('getProduct2');
      });
    } else {
      setCurrent(0);
    }
  }, [pageSize]);

  // const pageOnChange = (index) => {
  //   if (index && index > 0) {
  //     setCurrent(index - 1);
  //   }
  // };

  // const pageSizeChange = (size) => {
  //   const { value } = size;

  //   setPageSize(value);
  // };

  const scrollProps = React.useMemo(() => {
    return generateScrollProps(products);
  }, [(products || []).length]);

  // const tagText = useMemo(() => generateTags(filter, clearProductType), [
  //   filter,
  // ]);

  const displayBody = () => {
    if (hasInit) {
      if ((products || []).length === 0) {
        return (
          <NoProduct
            text={
              <div style={{ textAlign: 'center' }}>
                No results found, please try other key words (Sku No, product
                name etc.)
                <div style={{ paddingTop: 16 }}>or</div>
              </div>
            }
          />
        );
      } else {
        return (
          <React.Fragment>
            <SizeFittingTable
              rowKey='uuid'
              pagination={false}
              id='ProductSetProductsSelectionTable'
              columns={columns || _columns({ getI18n })}
              dataSource={products}
              rowSelection={rowSelection}
              // loading={loading}
              scroll={scrollProps}
            />
            {/* <Pagination
              current={current + 1}
              total={total}
              pageSize={pageSize}
              pageOnChange={pageOnChange}
              pageSizeChange={pageSizeChange}
              paginationProps={{ defaultPageSize: pageSize }}
            /> */}
          </React.Fragment>
        );
      }
    }
    return <div />;
  };

  return (
    <Modal
      title={getI18n('general.selectProduct')}
      visible={visible}
      width={900}
      onCancel={onCancel}>
      <div className={css.container}>
        {isTyped && (
          <ItemWrapper title={getI18n('general.productType')}>
            <RadioGroup
              value={currentProductsProperty}
              onChange={(e) => {
                const __condition: any = { ...(searchConditions || {}) };
                __condition.filter.productTypes = [];
                setSearchConditions(__condition);
                setCurrentProductsProperty(e.target.value);
                // clearMapKeys();
              }}>
              <div className={css.radioContainer}>
                <RadioItem
                  disabled={
                    selectedProductsProperty === EnumProductProperty.Virtual
                  }
                  value={EnumProductProperty.Physical}>
                  {getI18n('general.physicalProduct')}
                </RadioItem>
              </div>
              <div>
                <RadioItem
                  value={EnumProductProperty.Virtual}
                  disabled={
                    selectedProductsProperty === EnumProductProperty.Physical
                  }>
                  {getI18n('general.virtualProduct')}
                </RadioItem>
              </div>
            </RadioGroup>
          </ItemWrapper>
        )}
        <div className={css.queryContainer}>
          <_Query
            onSearchChange={(e) => {
              const _search = searchConditions.search;
              _search.push(e);
              setSearchConditions({ ...searchConditions, search: _search });
            }}
            onFilterChange={(e) => {
              let _filters = searchConditions.filter;
              _filters = { ...(_filters || {}), ...e };
              //console.log(_filters);
              setSearchConditions({ ...searchConditions, filter: _filters });
            }}
            onTagClose={(e) => {
              const _searchConditions = _.cloneDeep(searchConditions);
              const { queryType, key, value, relativeValue = [] } = e;
              if (queryType == 'search') {
                _searchConditions.search = _searchConditions.search.filter(
                  (i) => {
                    const { value: _value } = i;
                    return _value !== value;
                  },
                );
              }
              if (queryType == 'filter') {
                const _removeValues = [value, ...relativeValue];
                _searchConditions.filter[key] = _searchConditions.filter[
                  key
                ].filter((i) => {
                  const { value: _value } = i;
                  return !_removeValues.includes(_value);
                });
              }
              setSearchConditions(_searchConditions);
            }}
            filters={filters()}
            data={searchConditions || {}}
          />
        </div>
        {displayBody()}
      </div>
      {/* //  selectedRowKeys */}
      <ModalFooter
        front={
          <div className={css.footerTip}>{`${
            (selectedRowKeys || []).length
          } ${getI18n('general.itemsselected')}`}</div>
        }
        okText={getI18n('general.linkModule.Modal.add')}
        cancelText={getI18n('general.export1.cancel')}
        okClassName={css.okBtn}
        onOk={onOkPress}
        onCancel={onCancel}
      />
    </Modal>
  );
};
export default ProductSelection;
